import { releazioClient } from './client';
import type { ReleazioChannel, ReleazioConfigResponse } from './types';

export const fetchReleazioConfig = (channel: ReleazioChannel): Promise<ReleazioConfigResponse> =>
	releazioClient.get('', {
		searchParams: {
			channel,
		},
	}).json<ReleazioConfigResponse>();
